import React, { useState } from 'react';
import axios from 'axios';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const collectNotes = (slug, days) => {
  const notes = {};
  days.forEach((d) => {
    try {
      const v = localStorage.getItem(`lc_devotional_notes:${slug}:${d.day_number}`);
      if (v && v.trim()) notes[d.day_number] = v;
    } catch { /* private mode */ }
  });
  return notes;
};

export const NotesDownload = ({ slug, days }) => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    const notes = collectNotes(slug, days);
    if (!Object.keys(notes).length) {
      toast.info('No notes yet — jot a few thoughts under any day, then download them here.');
      return;
    }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/api/devotionals/${slug}/notes.pdf`, { notes }, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${slug}-my-notes.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success('Your notes are downloading');
    } catch {
      toast.error('Could not create the PDF. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={busy}
      className="inline-flex items-center gap-2 rounded-full border border-[#1f4d36] px-4 py-2 text-sm font-medium text-[#1f4d36] bg-white hover:bg-[#1f4d36] hover:text-white transition-colors disabled:opacity-60"
      data-testid="download-notes-pdf-btn"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
      Download my notes (PDF)
    </button>
  );
};
